import { defineSong } from '../types';

export default defineSong({
  id: 'gece-treni',
  title: 'Gece Treni',
  level: 2,
  key: 'Am',
  bpm: 100,
  beats: 4,
  pattern: 'D-DU-UDU',
  style: 'Türk rock',
  desc: "{{pc:A}} minörde i–iv–V: Türk pop ve rock'ın tanıdık rengi. V akoru majör ({{c:E}}).",
  sections: [
    { name: 'Giriş', bars: ['Am', 'Am', 'Dm', 'E'] },
    { name: 'Kıta', bars: ['Am', 'Dm', 'E', 'Am', 'Am', 'Dm', 'E', 'E'] },
    { name: 'Nakarat', bars: ['Dm', 'Am', 'E', 'Am', 'F', 'Dm', 'E', 'E'] },
  ],
  // Original lyrics written for kulaktan.com; each word with its length in beats.
  lyrics: [
    { bar: 5, text: 'Raylar:2 uzanır:2 karanlığa:4' },
    { bar: 7, text: 'Bir:1 istasyon:3 daha:2 geçer:2' },
    { bar: 9, text: 'Pencerede:4 kendi:2 yüzüm:2' },
    { bar: 11, text: 'Şehir:2 geride:2 kalır:4' },
    { bar: 13, text: 'Gece:2 treni,:2 götür:2 beni:2' },
    { bar: 15, text: 'Sabah:2 olmadan:3 uzağa:3' },
    { bar: 17, text: 'Her:1 vagonda:3 bir:1 hikâye:3' },
    { bar: 19, text: 'Benimki:3 de:1 seninle:4' },
  ],
});
